(function () {
  const PRODUCT_LIST_SELECTOR =
    ':is([data-testid="product-list"], .product-grid, .product-recommendations, [data-testid="resource-list-grid"])';
  const ACTIVE_ATTR = "data-cb-ho-active";

  function isProductListSwatchInput(target) {
    return (
      target instanceof HTMLInputElement &&
      target.name?.includes("-swatch") &&
      Boolean(target.closest(`${PRODUCT_LIST_SELECTOR} product-card`))
    );
  }

  function syncColorLabel(input) {
    const card = input.closest("product-card");
    const label = card?.querySelector("[data-cb-ho-color-label]");
    if (!label || !input.value) return;

    // Keep storefront locale text as rendered (Translate & Adapt); casing via CSS.
    label.textContent = input.value;
  }

  /**
   * Card galleries use absolute stacked slides (Chrisbella square crop).
   * Horizon slideshow may mark several slides aria-hidden=false (carousel viewport).
   * We own visibility with data-cb-ho-active — only one slide visible.
   */
  function showVariantMainImage(card, mediaId) {
    if (!card) return false;

    const slides = card.querySelectorAll(".card-gallery slideshow-slide");
    if (!slides.length) return false;

    let matched = null;
    slides.forEach((slide) => {
      const isMatch = mediaId && String(slide.getAttribute("slide-id")) === String(mediaId);
      if (isMatch) matched = slide;
      slide.removeAttribute(ACTIVE_ATTR);
      slide.removeAttribute("reveal");
      slide.setAttribute("aria-hidden", "true");
    });

    const active = matched || slides[0];
    if (!active) return false;

    active.removeAttribute("hidden");
    active.setAttribute(ACTIVE_ATTR, "");
    active.setAttribute("reveal", "");
    active.setAttribute("aria-hidden", "false");
    return Boolean(matched) || !mediaId;
  }

  function configureProductListCard(card) {
    if (!(card instanceof HTMLElement)) return;

    card.setAttribute("data-cb-ho-main-image-only", "");

    const gallery = card.querySelector(".card-gallery");
    if (gallery) {
      gallery.removeAttribute("on:pointerenter");
      gallery.removeAttribute("on:pointerleave");
      gallery.setAttribute("data-cb-ho-gallery", "");
    }

    // Disable hover-preview on swatches; click (change) handles main-image swap.
    card.querySelectorAll(".variant-option__button-label").forEach((label) => {
      label.removeAttribute("on:pointerenter");
      label.removeAttribute("on:pointerleave");
    });

    // Prefer checked swatch media; else first slide (featured / main image).
    const checked = card.querySelector('input[type="radio"][name*="-swatch"]:checked');
    const mediaId = checked?.dataset?.optionMediaId;
    showVariantMainImage(card, mediaId);
  }

  function handleProductListSwatchChange(event) {
    if (!isProductListSwatchInput(event.target)) return;

    const input = event.target;
    // Keep Chrisbella card behavior: swap main image only — no section re-fetch / detail carousel.
    event.stopImmediatePropagation();
    event.stopPropagation();

    const card = input.closest("product-card");
    const picker = card?.querySelector("swatches-variant-picker-component");
    const mediaId = input.dataset.optionMediaId;
    const variantId = input.dataset.firstAvailableOrFirstVariantId || input.dataset.variantId;

    picker?.updateSelectedOption?.(input);
    syncColorLabel(input);
    showVariantMainImage(card, mediaId);

    if (card && typeof card.applyVariantToLinks === "function" && variantId) {
      card.applyVariantToLinks(variantId, input.dataset.connectedProductUrl || undefined);
    }
  }

  function init(root = document) {
    root.querySelectorAll(`${PRODUCT_LIST_SELECTOR} product-card`).forEach(configureProductListCard);
  }

  document.addEventListener("change", handleProductListSwatchChange, true);

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => {
    if (event.target instanceof HTMLElement) init(event.target);
  });

  // Collection/search facets morph product cards without a full section reload.
  const observeRoots = () => {
    document.querySelectorAll("results-list, [data-testid='product-list'], product-recommendations, [data-testid='resource-list-grid']").forEach((root) => {
      if (!(root instanceof HTMLElement) || root.dataset.cbHoCardBridgeObserved) return;
      root.dataset.cbHoCardBridgeObserved = "true";
      const mo = new MutationObserver(() => init(root));
      mo.observe(root, { childList: true, subtree: true });
    });
  };
  observeRoots();
  document.addEventListener("shopify:section:load", observeRoots);
})();
